module.exports = __webpack_public_path__ + "img/truck-fast.0ddcc572.svg";